import { Button } from '@mui/material'
import { useCallback } from 'react'

import { RemoveButtonContainer } from './styles'

interface Props<T> {
	label: string
	onRemove: (value: T) => void
	value: T
}

const RemoveButton = <T,>({ label, onRemove, value }: Props<T>) => {
	const handleClick = useCallback(() => onRemove(value), [onRemove, value])
	return (
		<RemoveButtonContainer>
			<Button variant="text" onClick={handleClick} size="large">
				{label}
			</Button>
		</RemoveButtonContainer>
	)
}

export { RemoveButton }
